import { useEffect, useState } from 'react';
import './App.css';
import WordGame from './components/WordGame.js';
import AuthModal from './components/AuthModal.js';
import UserProfile from './components/UserProfile.js';
import { AuthProvider, useAuth } from './contexts/AuthContext.js';
import { LanguageProvider } from './contexts/LanguageContext.js';
import { preloadAllImages } from './utils/imageLoader.js';

// Main app content component (needs to be inside AuthProvider)
function AppContent() {
  const { loading } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showUserProfile, setShowUserProfile] = useState(false);

  // Show loading screen while Firebase initializes
  if (loading) {
    return (
      <div className="App">
        <div className="loading-screen">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {/* Main game component - now includes language toggle and auth buttons in HUD */}
      <WordGame
        onShowAuthModal={() => setShowAuthModal(true)}
        onShowUserProfile={() => setShowUserProfile(true)}
      />

      {/* Authentication modal */}
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        initialMode="login"
      />

      {/* User profile modal */}
      <UserProfile
        isOpen={showUserProfile}
        onClose={() => setShowUserProfile(false)}
      />
    </div>
  );
}

function App() {
  useEffect(() => {
    // Preload all letter and number images on app startup
    preloadAllImages();
  }, []);

  return (
    <AuthProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
